let domain = process.env.VUE_APP_API_DOMAIN;
let fileUploadUrl = process.env.VUE_APP_API_DOMAIN + "/common/upload";
let fileBase64UploadUrl = process.env.VUE_APP_API_DOMAIN + "/uploadBase64ImageFile";


export default {
  domain: domain,
  fileUploadUrl: fileUploadUrl,
  fileBase64UploadUrl: fileBase64UploadUrl,
  globalMixin: {
    data() {
      return {
        langData: ["English", "Simplified Chinese", "Traditional Chinese"],
        langKey: ["en_US", "zh_CN", "zh_HK"],
        fileUploadUrl: fileUploadUrl,
        fileBase64UploadUrl: fileBase64UploadUrl,
        pagesizeForm: 10,
        ACTIVE_STATUS: 6,
        apiDomain: domain,
        TOKEN_EXPIRED: "000104",
        apiConfig: {
          login: "/login",
          logout: "/logoutEx",
          createSystemUser: "/account/create",
          updateSystemUser: "/account/update",
          getSystemUserList: "/account/list",
          getSystemUserDetail: "/account/detail",
          delSystemUser: "/account/delete",
          accountForgetPwd: "/account/forgetPwd",
          accountResetPassword: "/account/resetPassword",

          getSystemRoleAllList: "/role/list",
          getSystemRoleDetail: "/role/detail",
          createSystemRole: "/role/create",
          updateSystemRole: "/role/update",
          deleteSystemRole: "/role/delete",
          getSystemFuncAllList: "/role/sysfunctions",


          accessLogList: "/accessLog/list",

          publishApi: "/publish",


          pushNotificationList: "/pushNotification/list",
          pushNotificationDetail: "/pushNotification/detail",
          pushNotificationCreate: "/pushNotification/create",
          pushNotificationUpdate: "/pushNotification/update",
          pushNotificationDelete: "/pushNotification/delete",
          pushNotificationCreatePushToPersons: "/pushNotification/createPushToPersons",
          pushNotificationUodatePushToPersons:'/pushNotification/updatePushToPersons',
          submitPushNotificationToPersons:'/pushNotification/submitPushNotificationToPersons',
          apporvePushNotificationToPersons:'/pushNotification/apporvePushNotificationToPersons',
          rejectPushNotificationToPersons:'/pushNotification/rejectPushNotificationToPersons',

          systemLogList: "/systemLog/list",
          systemLogUpdate: "/systemLog/update",

          newsList: "/news/list",
          newsDetail: "/news/detail",
          newsCreate: "/news/create",
          newsUpdate: "/news/update",
          newsDelete: "/news/delete",

          eventList: "/event/list",
          eventDetail: "/event/detail",
          eventCreate: "/event/create",
          eventUpdate: "/event/update",
          eventDelete: "/event/delete",
          eventOrder: "/event/order",
          eventSync: "/event/sync",
          eventPreposition: "/event/preposition",
          eventGetCaptchaImage: "/event/getCaptchaImage",

          upload: "/common/upload",
          getAllCategory: "/common/getAllCategory",
          getAllCategoryByType: "/common/getAllCategoryByType",
          download: "/common/download",

          categoryList: "/category/list",
          categoryDetail: "/category/detail",
          categoryCreate: "/category/create",
          categoryUpdate: "/category/update",
          categoryDelete: "/category/delete",

          termsConditonsDetail: "/termsConditons/list",
          termsConditonsUpdate: "/termsConditons/update",

          aboutDetail: "/about/list",
          aboutUpdate: "/about/update",

          aypDetail: "/ayp/list",
          aypUpdate: "/ayp/update",

          privacyDetail: "/privacy/list",
          privacyUpdate: "/privacy/update",

          eLearningList: "/e-learning/list",
          eLearningDetail: "/e-learning/detail",
          eLearningCreate: "/e-learning/create",
          eLearningUpdate: "/e-learning/update",
          eLearningDelete: "/e-learning/delete",
          eLearningOrder: "/e-learning/order",
          eLearningSubList: "/e-learning/sub/list",

          newsLetterList: "/newsLetter/list",
          newsLetterDetail: "/newsLetter/detail",
          newsLetterCreate: "/newsLetter/create",
          newsLetterUpdate: "/newsLetter/update",
          newsLetterDelete: "/newsLetter/delete",
          newsLetterOrder: "/newsLetter/order",

          landingPageDetail: "/landingPage/list",
          landingPageUpdate: "/landingPage/save",

          districtList: "/district/list",
          districtGetlist: "/district/getlist",

          staffUserList: "/staffUser/list",
          staffUserDetail: "/staffUser/detail",
          staffUserCreate: "/staffUser/create",
          staffUserUpdate: "/staffUser/update",
          staffUserDelete: "/staffUser/delete",

          giftDetailDetail: "/giftDetail/list",
          giftDetailUpdate: "/giftDetail/update",
          transferConfigLimit: "/sysConfig/getConfigInfo",
          transferConfigUpdate: "/sysConfig/update",
          transferConfigRedemptionReport: "/transferConfig/redemptionReport",

          giftList: "/gift/list",
          giftDetail: "/gift/detail",
          giftCreate: "/gift/create",
          giftUpdate: "/gift/update",
          giftDelete: "/gift/delete",
          giftOrder: "/gift/order",

          systemApproveList: "/systemApprove/list",
          systemApproveUpdate: "/systemApprove/update",
          systemApprovePublish: "/systemApprove/publish",

          imgbannerList: "/imgbanner/list",
          imgbannerDetail: "/imgbanner/detail",
          imgbannerCreate: "/imgbanner/create",
          imgbannerUpdate: "/imgbanner/update",
          imgbannerDelete: "/imgbanner/delete",

          stemupUpload: "/stemup/upload",
          stemupList: "/stemup/list",
          stemupDetail: "/stemup/detail",
          stemupFiles: "/stemup/files",
          stemupUpdate: "/stemup/update",
          stemupExport: "/stemup/export",
          stemupEmails: "/stemup/emails",
          stemupRatings: "/stemup/ratings",

          schooluserList: "/schooluser/list",
          schoolUserCreate: "/schooluser/create",
          schoolUserUpdate: "/schooluser/update",
          schoolUserDelete: "/schooluser/delete",
          schoolUserDetail: "/schooluser/detail",
          schoolCodeList: "/school/list",

          schoolImgBannerList: "/schoolImgBanner/list",
          schoolImgBannerDelete: "/schoolImgBanner/delete",
          schoolImgBannerDetail: "/schoolImgBanner/detail",
          schoolImgBannerCreate: "/schoolImgBanner/create",
          schoolImgBannerUpdate: "/schoolImgBanner/update",
          schoolImgBannerOrder: "/schoolImgBanner/order",

          schoolResourcesCategoryList: "/schoolResourcesCategory/list",
          schoolResourcesCategoryDelete: "/schoolResourcesCategory/delete",
          schoolResourcesCategoryDetail: "/schoolResourcesCategory/detail",
          schoolResourcesCategoryCreate: "/schoolResourcesCategory/create",
          schoolResourcesCategoryUpdate: "/schoolResourcesCategory/update",

          schoolResourcesList: "/schoolResources/list",
          schoolResourcesDelete: "/schoolResources/delete",
          schoolResourcesDetail: "/schoolResources/detail",
          schoolResourcesCreate: "/schoolResources/create",
          schoolResourcesUpdate: "/schoolResources/update",

          schoolEventList: '/schoolEvent/list',
          schoolEventDetail: '/schoolEvent/detail',
          schoolEventDelete: '/schoolEvent/delete',
          schoolEventCreate: '/schoolEvent/create',
          schoolEventUpdate: '/schoolEvent/update',
          schoolEventUpdateStatus: '/schoolEvent/updateStatus',
          schoolEventOrder: "/schoolEvent/order",
          schoolEventUpdateArchivedStatus: "/schoolEvent/updateArchivedStatus",
          schoolResourcesUpdateStatus: '/schoolResources/update',

          giftStoreList:"/giftStore/list",
          giftStoreCreate:"/giftStore/create",
          giftStoreUpdate:"/giftStore/update",
          giftStoreDetail:"/giftStore/detail",
          giftStoreDelete:"/giftStore/delete",
          giftStoreOrder:"/giftStore/order",

          giftInventoryLogList:"/giftInventoryLog/list",
          giftInventoryLogCreate:"/giftInventoryLog/create",
          giftInventoryLogDetail:"/giftInventoryLog/detail",
          giftInventoryExport:"/giftInventoryLog/export",
          giftInventoryExportStoreInventory:"/giftInventoryLog/exportGiftStoreInventory",
          giftInventoryImport:"/giftInventoryLog/import",

          giftRequestList:"/giftRequest/list",
          giftRequestUpdateStatus:"/giftRequest/updateStatus",
          giftRequestDetail:"/giftRequest/detail",
          giftRequestUpdate:"/giftRequest/update",
          giftRequestPush:"/giftRequest/rePush",

          giftCategoryList: "/giftCategory/list",
          giftCategoryDelete: "/giftCategory/delete",
          giftCategoryDetail: "/giftCategory/detail",
          giftCategoryCreate: "/giftCategory/create",
          giftCategoryUpdate: "/giftCategory/update",

          giftDeliveryList: "/giftDelivery/list",
          giftDeliveryCreate: "/giftDelivery/create",
          giftDeliveryUpdateStatus: "/giftDelivery/updateStatus",
          giftDeliveryNote: "/giftDelivery/deliveryNote",

          memberCommentBoxList :"/memberCommentBox/list",
          memberCommentBoxDetail :"/memberCommentBox/detail",
          memberCommentBoxUpdate :"/memberCommentBox/updateStatus",
          memberCommentBoxExport :"/memberCommentBox/exportFeedbackInfo",

          memberCommentBoxDistrictEmailList :"/district/list",
          memberCommentBoxDistrictEmailUpdate :"/district/updateDistrictFeedBackEmail",

          userStampUpdateLogList :"/userStampUpdateLog/list",
          userStampUpdateLogDetail :"/userStampUpdateLog/detail",
          userStampUpdateLogCreate :"/userStampUpdateLog/create",
          userStampUpdateLogBatchCreate :"/userStampUpdateLog/batchCreate",

          externalUserList: "/externalUser/list",
          externalUserDelete: "/externalUser/delete",
          externalUserDetail: "/externalUser/detail",
          externalUserCreate: "/externalUser/create",
          externalUserUpdate: "/externalUser/update",

          publicityList: "/publicity/list",
          publicityDetail: "/publicity/detail",
          publicityCreate: "/publicity/create",
          publicityUpdate: "/publicity/update",
          publicityDelete: "/publicity/delete",
          publicityOrder: "/publicity/order",
          publicityPreposition: "/publicity/preposition",

          publicityCategoryList: "/code/list",
          publicityCategoryDelete: "/code/delete",
          publicityCategoryDetail: "/code/detail",
          publicityCategoryCreate: "/code/create",
          publicityCategoryUpdate: "/code/update",
        }
      }
    },
    methods: {
      checkPermission(permission) {
        if (!permission) return true;
        if (this.$store.state && this.$store.state.userInfo && this.$store.state.userInfo.systemActions) {
          let actions = this.$store.state.userInfo.systemActions;
          let found = false;
          actions.forEach(item => { if (item.code === permission) { found = true } });
          if (found) return found;
        }
      },
      setFormData(data) {
        var params = new URLSearchParams();
        for (var key in data) {
          if (data[key] !== null && data[key] !== undefined) {
            params.append(key, data[key]);
          }
        }
        return params;
      },
      getObject(object, langCode) {
        return !object || object.length == 0 ? {} : object.find(o => o.langCode == langCode);
      },
      deleteObj: function (obj, index) {
        obj.splice(index, 1);
      },
      showWarning() {
        var that = this;
        if (this.multipleSelection.length != 0) {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.$store.commit("setwarning", { string: "", boolean: false });
                that.deleteList();
              }
            }, {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () { that.$store.commit("setwarning", { string: "", boolean: false }); }
            }]
          });
        }
      },
      sortChange: function (val) {
        if (val.order == 'ascending') {
          this.sortType = 'ASC';
          this.sortField = val.prop;
        } else if (val.order == "descending") {
          this.sortType = 'DESC';
          this.sortField = val.prop;
        } else {
          this.sortType = 'ASC';
          this.sortField = 'id';
        }
        this.init();
      },
      handleSizeChange: function (val) {
        this.pagesize = val;
        this.init();
      },
      handleCurrentChange: function (val) {
        this.page = val;
        this.init();
      },
      handleSelectionChange: function (val) {
        this.multipleSelection = val;
      },
      cancel: function () {
        this.$store.commit("setwarning", { string: "", boolean: false });
      },
      getAuthObj() {
        let obj = {};
        obj.userId = this.$store.state.userInfo.userId;
        obj.token = this.$store.state.userInfo.token;
        return obj;
      },
      timeoutEvent() {
        this.$router.push({ path: "/" });
      },
      dateFormat(long) {
        if (!long) {
          return ""
        }
        var timeStamp = new Date(long);
        var year = timeStamp.getFullYear();
        var shortYear = year.toString().substring(2);
        var month = timeStamp.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var date = timeStamp.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var hour = timeStamp.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var seconds = timeStamp.getSeconds();
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var minutes = timeStamp.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        return year + '-' + month + '-' + date + ' ' + hour + ":" + minutes + ":" + seconds
      }
    },
    computed: {
    }
  }

};